module.exports = __webpack_public_path__ + "static/media/alert-triangle.a0819d29.svg";